import type { AppModule } from '@shared/constants/system/app';

export const MAX_REPORT_BULK_DELETE_IDS = 100;

export const REPORT_TYPES = {
    CLAIMS: 'CLAIMS',
    CLAIMS_BORDEREAU: 'CLAIMS_BORDEREAU',
    CLAIMS_GICOP_BREACH: 'CLAIMS_GICOP_BREACH',
    COMPLAINTS: 'COMPLAINTS',
    COMPLAINTS_ASIC_2023: 'COMPLAINTS_ASIC_2023',
    INCIDENTS: 'INCIDENTS',
    IBCCC_BREACH_2025: 'IBCCC_BREACH_2025',
    STAFF_TRAINING_SUMMARY: 'STAFF_TRAINING_SUMMARY',
    STAFF_TRAINING_DETAILED: 'STAFF_TRAINING_DETAILED',
    RISK: 'RISK',
} as const;

export type ReportType = (typeof REPORT_TYPES)[keyof typeof REPORT_TYPES];

/** Maps each report type to its parent AppModule for analytics */
export const REPORT_TYPE_MODULE_MAP: Record<ReportType, AppModule> = {
    [REPORT_TYPES.CLAIMS]: 'claim',
    [REPORT_TYPES.CLAIMS_BORDEREAU]: 'claim',
    [REPORT_TYPES.CLAIMS_GICOP_BREACH]: 'claim',
    [REPORT_TYPES.COMPLAINTS]: 'compliance',
    [REPORT_TYPES.COMPLAINTS_ASIC_2023]: 'compliance',
    [REPORT_TYPES.INCIDENTS]: 'compliance',
    [REPORT_TYPES.IBCCC_BREACH_2025]: 'compliance',
    [REPORT_TYPES.STAFF_TRAINING_SUMMARY]: 'compliance',
    [REPORT_TYPES.STAFF_TRAINING_DETAILED]: 'compliance',
    [REPORT_TYPES.RISK]: 'risk',
} as const;
